module.exports = "https://99designs-start-assets.imgix.net/js/d2761ee013273008dbd0f27a635a376b.png";